import BasePreloader from '../../BasePreloader';
import logo818 from './assets/logo_818.webp';
import onlyplayLogo from '../../assets/logo.svg';
import './preloader818.css'

export default class Preloader818 extends BasePreloader {
  createMarkup() {
    document.body.insertAdjacentHTML('beforeend',
      `<div id="preloader" class="preloader branding_818">
        <div class="preloaderContainer">
          <object data="${logo818}" class="preloaderLogoBase preloaderLogo branding_logo_818"></object>
          <div id="percents">0%</div>
          <div class="progressContainer">
            <div class="progressBg">
              <div id="progressBar" class="progress"></div>
            </div>
          </div>
          <span class="branding_powered_text_818">POWERED BY</span>
          <object data="${onlyplayLogo}" class="preloaderLogoBase preloaderLogo branding_onlyplay_logo_818"></object>
        </div>
      </div>`);

    this.preloaderElement = document.getElementById('preloader');
    this.progressBar = document.getElementById('progressBar');
  }
}
